export default __webpack_public_path__ + "static/media/icon_arrow_down_light_24x24.890f3fad.svg";